import React from 'react';
import DataGrid from '../../components/DataGrid/DataGrid';
import CardPointsAdd from './CardPointsAdd';
import DetailDialog from '../../components/DetailDialog/DetailDialog';
import { Box } from '@mui/material';
import { Add } from '@mui/icons-material';

// the backend id not standard here !!
const CardPoints = ({card, partnerId}) => {
    const [openEditor, setOpenEditor] = React.useState(false);
    const columns = [
        { field: "id", headerName: "ID", align: "left", filterable: true, },
        { field: "plus", headerName: "Plus", align: "left", filterable: true, permanent: true,},
        { field: "minus", headerName: "Minus", align: "left", filterable: true, permanent: true,},
        { field: "comment", headerName: "Comment", align: "left", filterable: true, permanent: true,},
        { field: "nature", headerName: "Nature", align: "left", filterable: true,},

    ];

    const headerActions = [
                { name: "Add", icon: <Add fontSize="small" color='secondary' />, onClick: () => setOpenEditor(true) },
            ];

    return (
        <div>
            <DataGrid 
                columns={columns} 
                endPoint={`/api/v2/partner/${partnerId}/cards/${card.id}/points`}  
                exportFileName='CardPoints' 
                headerActions={headerActions}
            />
            <DetailDialog 
                open={openEditor} 
                onClose={()=>setOpenEditor(false)} 
                title={"New Card"}
                fullScreen={false}>
                    <Box sx={{p:2}}>
                        <CardPointsAdd partnerId={partnerId} idCard={card.id} onSave={()=>setOpenEditor(false)} onCancel={()=>setOpenEditor(false)} />
                    </Box>
            </DetailDialog>
        </div>
    );
};

export default CardPoints;